module.exports = __webpack_public_path__ + "media/kilkenny-college.18cc338b.mp4";